import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { InfoField, ChipBox, ChipType } from '@occc/ui-design-system';
import { useConfig } from '@occc/config';
import { segmentsRouteCreatorFactory } from '@occc/feat-segments/segments.router';

import { Segment as SegmentAttribute } from '../../types';

const getAudienceType = (attribute: SegmentAttribute) => {
  if (attribute.__typename === 'AudienceInAllSegmentsTargetingAttribute') {
    return 'in all';
  }

  if (attribute.__typename === 'AudienceInAnySegmentsTargetingAttribute') {
    return 'in any';
  }

  if (attribute.__typename === 'AudienceNotInAnySegmentsTargetingAttribute') {
    return 'NOT in';
  }

  return '-';
};

export type SegmentProps = {
  attribute: SegmentAttribute;
};

export const Segment: React.FC<SegmentProps> = ({ attribute }) => {
  const { version: segmentsVersion } = useConfig('features.segments');
  const { routeCreator } = segmentsRouteCreatorFactory(segmentsVersion);

  const navigate = useNavigate();
  const onChipClick = React.useCallback(
    (segmentUuid: string) => {
      navigate(routeCreator.details(segmentUuid));
    },
    [navigate, routeCreator],
  );

  const chipBoxItems: ChipType[] = useMemo(() => {
    return attribute.segments.map((segment) => ({
      id: segment.uuid,
      name: segment.name,
    }));
  }, [attribute.segments]);

  const audienceType = getAudienceType(attribute);
  const value = chipBoxItems.length ? (
    <ChipBox items={chipBoxItems} onClick={onChipClick} mt={0} />
  ) : null;

  return (
    <InfoField label={`Members are ${audienceType} segments`} value={value} disableTypography />
  );
};
